/*eslint-disable eqeqeq */
import axios from 'axios';
import HttpHeader from '../Member/shared/httpheader';
import decryption from '../Member/shared/Decryption';
import generateToken from '../Member/shared/Generatetoken';
import {
  setContentLoader,
  unSetContentLoader,
  setRedirectOnError,
  setIsTokenExpired,
} from '../redux/app/appSlice';
import { logout, setBearerToken, setIsLoggedIn } from '../redux/app/userSlice';

let store;
export const injectStoreWithTimeout = (_store) => {
  store = _store;
};

const axiosInstanceWithTimeout = axios.create({
  timeout: 15000,
});
//Add a request interceptor
axiosInstanceWithTimeout.interceptors.request.use(
  (config) => {
    console.log('API REQUEST ----------' + config?.url);
    console.log('START TIME -----------' + new Date());
    //application/json
    config.headers['Accept'] = 'application/json';
    const currentUrl = config?.url;
    config.headers['isLocal'] = 'true';
    if (!currentUrl.includes('api.ipify.org'))
      config.headers['X-ClientID'] = HttpHeader.getCNAME();

    if (!config.headers['Accept']) {
      config.headers['Accept'] = 'application/json';
    }

    if (!config.headers['Content-Type']) {
      config.headers['Content-Type'] = 'application/json';
    }

    if (
      !currentUrl.includes('keystore/getkeystore/name/portal/') &&
      !currentUrl.includes('keystore/getkeystore/name/payload') &&
      !currentUrl.includes('api.ipify.org')
    ) {
      if (!config?.headers?.Authorization) {
        const bearerToken = store.getState().user.bearerToken;
        if (bearerToken) {
          config.headers['authorization'] = bearerToken;
        }
      }
    }

    if (currentUrl.includes('/dms/document/oid/')) {
      config.headers['Accept'] = 'image/png';
    } else {
      const loadingNum = store.getState().app.loadingNum;
      if (loadingNum == 0) {
        store.dispatch(setContentLoader());
      }
    }

    if (!currentUrl.includes('api.ipify.org')) {
      config.params = { ...config.params, cb: Date.now() };
    }

    //config.onDownloadProgress = progressEvent => {
    //console.log('progressEvent', progressEvent)
    //const percentCompleted = Math.floor((progressEvent.loaded * 100) / progressEvent.total);
    //// do whatever you like with the percentage complete
    //// maybe dispatch an action that will update a progress bar or something
    //// alert(percentCompleted)
    //store.dispatch(setLoadingProgress(percentCompleted || 15));
    //}
    return config;
  },
  (error) => {
    return Promise.reject(error);
  },
);

//Add a response interceptor
axiosInstanceWithTimeout.interceptors.response.use(
  (response) => {
    console.log('API RESPONSE ---------' + response?.config?.url);
    console.log('END TIME -----------' + new Date());
    const currentUrl = response?.config?.url;
    //store.dispatch(setLoadingProgress(100));
    store.dispatch(unSetContentLoader());
    let key = store.getState().key.encryptionValue.SymmetricKey;
    if (currentUrl.includes('keystore/getkeystore/name/payload')) {
      key = response?.data?.Response?.SymmetricKey;
      return response;
    }

    if (currentUrl.includes('/dms/document/oid/')) {
      return response;
    }

    if (currentUrl.includes('keystore/getkeystore/name/portal/') && key) {
      const keyStoreDataResp = decryption(response.data, key);
      const token = generateToken(keyStoreDataResp);

      if (!store.getState().user.bearerToken) {
        store.dispatch(setBearerToken('Bearer ' + token));
      }
      return keyStoreDataResp;
    } else if (currentUrl.includes('/authorization/login/portal/') && key) {
      const loginData = decryption(response.data, key);
      const bearerToken =
        'Bearer ' +
        loginData.Response.access_token +
        ',' +
        loginData.Response.refresh_token;
      store.dispatch(setBearerToken(bearerToken));
      response.data = loginData;
      return response;
    } else {
      const token = response.headers.authorization;

      try {
        if (response.data && typeof response.data === 'string') {
          store.dispatch(setBearerToken(token));
          const allData = decryption(response.data, key);
          response.data = allData;
        }
        return response;
      } catch (error) {
        return response;
      }
    }
  },
  (error) => {
    const currentUrl = error?.response?.config?.url;
    store.dispatch(unSetContentLoader());
    if (
      !currentUrl.includes('/authorization/login/portal') &&
      error?.response?.status === 401
    ) {
      if (store.getState().app.portalType === 'admin') {
        store.dispatch(logout());
        store.dispatch(setIsTokenExpired(true));
      }
      if (store.getState().app.portalType === 'member') {
        //store.dispatch( logout() );
        window.location.href = '/member/session-expired';
      }
      //window.location.href = 'session-expired';
    }
    //if (error?.response?.status === 500) {
    //store.dispatch(setRedirectOnError(true));
    //}
    return Promise.reject(error);
  },
);

export default axiosInstanceWithTimeout;
